import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

/**
 * IE böngészőt használja a user.
 * @param ua - UserAgent.
 */
export default function isIE (ua: string): boolean { // eslint-disable-line @typescript-eslint/naming-convention
  return userAgentParser.isIE(ua)
}
